import { cva } from 'class-variance-authority'

export const emptyStateVariants = cva('', {
  variants: {
    textSize: {
      xs: 'text-xs',
      sm: 'text-sm',
      inherit: '',
    },
  },
  defaultVariants: {
    textSize: 'inherit',
  },
})
